"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RegionTitle = exports.RegionIcon = exports.RegionContainer = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const Typography_1 = __importDefault(require("../../../UI/Typography"));
const svg_components_1 = require("../../../../assets/svg-components");
exports.RegionContainer = styled_components_1.default.button `
  border: 0;
  background-color: transparent;
  display: flex;
  flex-direction: row;
  align-items: center;
  cursor: pointer;
`;
exports.RegionIcon = (0, styled_components_1.default)(svg_components_1.RegionIcon) `
  > path {
    transition: ${props => props.theme.attributes.transition.fast};
    stroke: ${props => (props.$isTransparent ? props.theme.palette.BW_100 : props.theme.palette.LIGHT_BLACK)};
  }
`;
exports.RegionTitle = (0, styled_components_1.default)(Typography_1.default) `
  font-weight: ${props => props.theme.typography.weight.regular};
  margin-left: ${props => props.theme.spacing.s1}px;
  color: ${props => (props.$isTransparent ? props.theme.palette.BW_100 : 'inherit')};
`;
exports.default = {
    RegionContainer: exports.RegionContainer,
    RegionIcon: exports.RegionIcon,
    RegionTitle: exports.RegionTitle
};
